import React from "react";
import RequestForm from "./RequestForm";
import AddMinorRequestForm from "./AddMinorRequestForm";
import AddCertRequestForm from "./AddCertRequestForm";
import Confirmation from "./Confirmation";
import ConfirmationMinors from "./ConfirmationMinors";
import ConfirmationCerts from "./ConfirmationCerts";
import Notice from "./Notice";
import Ineligible from "./Ineligible"
import IneligibleCerts from "./IneligibleCerts"

import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";



const App = {
  App() {
    
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={RequestForm} /> 
          <Route path="/request" component={RequestForm} />
          <Route path="/minors" component={AddMinorRequestForm} />
          <Route path="/certs" component={AddCertRequestForm} />
          <Route path="/confirmation" component={Confirmation} />
          <Route path="/confirmationMinors" component={ConfirmationMinors} />
          <Route path="/confirmationCerts" component={ConfirmationCerts} />
          <Route path="/notice" component={Notice} /> 
          <Route path="/ineligible" component={Ineligible} /> 
          <Route path="/ineligibleCerts" component={IneligibleCerts} /> 
        </Switch>
      </Router>
    );
  },
};



export default App;
